import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Moon, Sun, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/context/ThemeContext";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

const links = [
  { label: "Fonctionnalités", href: "#features" },
  { label: "Studio IA", href: "#studio" },
  { label: "Tarifs", href: "/pricing" },
  { label: "Tableau de bord", href: "/dashboard" },
  { label: "Connexion", href: "/login" },
];

export const Navbar = () => {
  const { theme, toggle } = useTheme();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const go = (href) => {
    setOpen(false);
    if (href.startsWith("/")) navigate(href);
    else if (window.location.pathname === "/") document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    else navigate("/" + href);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 px-4 pt-4">
      <nav className="max-w-7xl mx-auto mg-glass rounded-2xl px-4 sm:px-6 h-16 flex items-center justify-between">
        <Logo onClick={() => navigate("/")} />

        <div className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <button
              key={l.label}
              onClick={() => go(l.href)}
              className="px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors rounded-lg hover:bg-secondary"
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-").replace(/[éè]/g, "e")}`}
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <button onClick={toggle} className="h-9 w-9 flex items-center justify-center rounded-lg hover:bg-secondary transition-colors" data-testid="theme-toggle">
            {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          {user ? (
            <Button onClick={() => navigate(user.role === "admin" ? "/admin" : "/dashboard")} className="hidden sm:flex rounded-xl" data-testid="nav-dashboard-btn">
              Mon espace
            </Button>
          ) : (
            <>
              <Button variant="ghost" onClick={() => navigate("/login")} className="hidden sm:flex rounded-xl" data-testid="nav-login-btn">
                Connexion
              </Button>
              <Button onClick={() => navigate("/register")} className="rounded-xl bg-gradient-to-r from-indigo-500 to-cyan-500 hover:opacity-90 text-white border-0" data-testid="nav-register-btn">
                Démarrer
              </Button>
            </>
          )}
          <button onClick={() => setOpen(!open)} className="lg:hidden h-9 w-9 flex items-center justify-center rounded-lg hover:bg-secondary" data-testid="mobile-menu-toggle">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden max-w-7xl mx-auto mt-2 mg-glass rounded-2xl p-4 flex flex-col gap-1">
          {links.map((l) => (
            <button key={l.label} onClick={() => go(l.href)} className="text-left px-3 py-2.5 rounded-lg hover:bg-secondary text-sm font-medium">
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};

export default Navbar;
